import { Descriptions } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cashConverter } from "../../../../utils";

function ProjectDetailsSub({ handleExpand, expand }) {
  const { activeObjexpIsp } = useSelector((state) => ({
    activeObjexpIsp: state.obj.activeObj["expressionIsp"],
  }));
  const navigate = useNavigate();
  const handleEdit = () => {
    navigate("/expression-add");
  }; 
  const items1 = [
    {
      key: "1",
      label: "Bid Acceptance Date",
      children: (
        <div>
          {activeObjexpIsp?.createdDate
            ? moment(activeObjexpIsp?.createdDate)?.format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : "--"}
        </div>
      ),
    },
    {
      key: "5",
      label: "Registration Date",
      children: (
        <div>
          {activeObjexpIsp?.createdDate
            ? moment(activeObjexpIsp?.createdDate)?.format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : "--"}
        </div>
      ),
    },
    {
      key: "2",
      label: "Project Completion Date",
      children: (
        <div>
          {activeObjexpIsp?.projectEndDate
            ? moment(activeObjexpIsp?.projectEndDate)?.format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : "--"}
        </div>
      ),
    },
    {
      key: "1",
      label: "Project Start Date",
      children: (
        <div>
          {activeObjexpIsp?.projectStartDate
            ? moment(activeObjexpIsp?.projectStartDate)?.format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : "--"}
        </div>
      ), 
    },

    {
      key: "3",
      label: "Irrigation Type",
      children: activeObjexpIsp?.irrigationType ?? "N/A",
    },
    {
      key: "4",
      label: "Major Crops",
      children: activeObjexpIsp?.majorCrop ?? "N/A",
    },
    
  ];
  const items2 = [
    {
      key: "6",
      label: "Water Quantity (L)",
      children: activeObjexpIsp?.waterQuantity ?? "N/A",
    },
    {
      key: "2",
      label: "County",
      children: activeObjexpIsp?.countyName ?? "N/A",
    },
    {
      key: "3",
      label: "Estimated Cost",
      children:<div>{cashConverter(activeObjexpIsp?.estimatedCost )}</div>,
    },
    {
      key: "4",
      label: "Number of Farmers",
      children: activeObjexpIsp?.numberOfFarmers ?? "N/A",
    },
    {
      key: "6",
      label: "Water Source",
      children: activeObjexpIsp?.waterSource ?? "N/A",
    },
    {
      key: "7",
      label: "Water Quality",
      children: activeObjexpIsp?.waterQuality ?? "N/A",
    },
  ];
  const items3 = [
  

    {
      key: "2",
      label: "SubCounty",
      children: activeObjexpIsp?.location ?? "N/A",
    },
    {
      key: "3",
      label: "Land Size",
      children: activeObjexpIsp?.landSize ?? "N/A",
    },
    {
      key: "4",
      label: "Number of Household",
      children: activeObjexpIsp?.numberOfHouseholds ?? "N/A",
    },
    {
      key: "6",
      label: "Water Abstraction Permit Number",
      children: activeObjexpIsp?.waterAbstractionPermit ?? "N/A",
    },
  ];
  return (
    <div className={`${expand && "white_card mt-[1.75rem]"}`}>
      <div
        className={`mt-[1.75rem] flex items-center justify-between  w-full `}
      >
        <div className="details_h  w-full">Project Details</div>
        <div className="flex  justify-end  w-full   text-[#424242] font-[400[ text-[.75rem] font-interSans gap-x-[1.25rem]">
          <span className="underline cursor-pointer" onClick={handleExpand}>
            {expand ? "Collapse" : "Expand"}
          </span>
          
        </div>
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          column={1}
          colon={false}
          items={items1}
          layout="vertical"
        />
        <Descriptions
          column={1}
          colon={false}
          items={items2}
          layout="vertical"
        />
        <Descriptions
          column={1}
          colon={false}
          items={items3}
          layout="vertical"
        />
      </div>
    </div>
  );
}

export default ProjectDetailsSub;
